import React, { Component } from 'react'
import { View } from 'react-native'

import { Text } from '../../Atoms/Typography'
import CenteredSpinner from '../../Atoms/Spinner/CenteredSpinner'
import ValueChangeText from '../../Molecules/ValueChangeText'
import LoadAfterDelay from '../../Hocs/LoadAfterDelay'
import TranslatedText from '../../Atoms/TranslatedText'
import { thousandSeparator, percentage } from '../../../lib/formatters'
import { Column, borderHack } from './Table'

import styled from 'styled-components/native'
import { lighten } from 'polished'
import theme from '../../../styles/theme'

import { mapNames } from '../../../lib/business-formatters'
import { translate } from '../../../services/translate'

const { gutterUnit } = theme

const Container = styled(View)`
  flex: 1;
  align-items: center;
  width: 100%;
`

const Table = styled(View)`
  flex: 1;
  flex-direction: row;
  width: 100%;
`

const TableSection = styled(View)`
  borderBottomColor: ${theme.colours.bordergrey};
  borderBottomWidth: 1px;
  borderRightColor: ${theme.colours.bordergrey};
  borderRightWidth: 1px;
`

const Row = styled(View)`
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: ${props => props.height}px;
`

const RowStart = styled(Row)`
  justify-content: flex-start;
`

const Column1 = styled(View)`
  width: 24%;
  flex-direction: column;
`

const ColumnDesc = styled(View)`
  justify-content: center;
  padding-left: ${gutterUnit}px;
`

const Column2 = styled(View)`
  width: 19%;
  flex-direction: column;
`

const ColumnValue = styled(Column)`
  width: 50%;
  height: 100%;
  justify-content: flex-end;
  background-color: ${props => props.colour};
  padding-right: ${gutterUnit}px;
  padding-left: 0;
`

const ColumnChange = styled(Column)`
  width: 50%;
  padding: 0 ${gutterUnit}px;
`

const formatValue = (val) => {
  if (val === 0) {
    return '-'
  }
  if (val < 0) {
    return `(${thousandSeparator(val * -1)})`
  }
  return thousandSeparator(val)
}

const formatPercentage = (val) => {
  if (val === 0) {
    return '-'
  }
  return percentage(val)
}

const businessColours = {
  1: lighten(0.4, theme.colours.orange),
  2: lighten(0.37, theme.colours.blue),
  3: lighten(0.37, theme.colours.magenta),
  4: lighten(0.4, theme.colours.green),
  5: lighten(0.4, theme.colours.green),
  6: lighten(0.4, theme.colours.green),
  7: lighten(0.4, theme.colours.green)
}

const heightForNumberOfRows = {
  21: 30.8,
  20: 32,
  19: 33.4,
  18: 34.9,
  17: 37
}
class FinancialDivisionProfitAndLoss extends Component {
  shouldComponentUpdate (nextProps, nextState) {
    if (nextProps.loaded && !this.props.loaded) {
      return true
    }
    if (!nextProps.active) {
      return false
    }
    return true
  }

  renderForBusinesses = (render) => {
    return this.props.data.businesses.map((b, index) => {
      if (b.businessName === 'INSTITUTIONAL BANKING') {
        b.businessName = 'INSTITUTIONAL'
      }
      return render({ b, colour: businessColours[b.businessId] })
    })
  }

  render () {
    const { loaded, round, denomination, fundsMgmtIncomeEnabled, creditCardsEnabled, institutionalBankingEnabled } = this.props
    const numOfRows = 21 - !fundsMgmtIncomeEnabled - !institutionalBankingEnabled - (2 * !creditCardsEnabled)
    const rowHeight = heightForNumberOfRows[numOfRows]
    return (
      <Container>
        <Table>
          <Column1>
            <TableSection style={{ backgroundColor: theme.colours.darkBlue }}>
              <RowStart height={rowHeight}><ColumnDesc><TranslatedText size='s' bold white uppercase value='ourFinancials.divisionalProfitLoss.screenHeader' default='PROFIT & LOSS BY DIVISION' /></ColumnDesc></RowStart>
              <RowStart height={rowHeight}><ColumnDesc><Text size='s' medium bold white>{denomination}</Text></ColumnDesc></RowStart>
            </TableSection>
            <TableSection>
              <RowStart height={rowHeight}><ColumnDesc><TranslatedText size='s' value='ourFinancials.divisionalProfitLoss.interestIncome' default='Interest Income' /></ColumnDesc></RowStart>
              <RowStart height={rowHeight}><ColumnDesc><TranslatedText size='s' value='ourFinancials.divisionalProfitLoss.interestExpense' default='Interest Expense' /></ColumnDesc></RowStart>
            </TableSection>
            <TableSection>
              <RowStart height={rowHeight}><ColumnDesc><TranslatedText size='s' bold uppercase value='ourFinancials.divisionalProfitLoss.netInterestIncome' default='NET INTEREST INCOME' /></ColumnDesc></RowStart>
              <RowStart height={rowHeight}><ColumnDesc><TranslatedText size='s' medium colour={theme.colours.blue} value='ourFinancials.divisionalProfitLoss.netInterestMargin' default='Net Interest Margin %' /></ColumnDesc></RowStart>
              <RowStart height={rowHeight}><ColumnDesc><TranslatedText size='s' value='ourFinancials.divisionalProfitLoss.brokerCommissions' default='Broker Commissions' /></ColumnDesc></RowStart>
              <RowStart height={rowHeight}><ColumnDesc><TranslatedText size='s' value='ourFinancials.divisionalProfitLoss.cardTransactionIncome' default='Transaction & Fee Income' /></ColumnDesc></RowStart>
              {creditCardsEnabled && <RowStart height={rowHeight}><ColumnDesc><TranslatedText size='s' value='ourFinancials.divisionalProfitLoss.creditCardFees' default='Credit Card Fees' /></ColumnDesc></RowStart>}
              {creditCardsEnabled && <RowStart height={rowHeight}><ColumnDesc><TranslatedText size='s' value='ourFinancials.divisionalProfitLoss.creditCardRewardCosts' default='Credit Card Reward Costs' /></ColumnDesc></RowStart>}
              {institutionalBankingEnabled && <RowStart height={rowHeight}><ColumnDesc><TranslatedText size='s' value='ourFinancials.divisionalProfitLoss.institutionalBankingFees' default='Institutional Banking Fees' /></ColumnDesc></RowStart>}
            </TableSection>
            <TableSection>
              <RowStart height={rowHeight}><ColumnDesc><TranslatedText size='s' bold uppercase value='ourFinancials.divisionalProfitLoss.otherBankingIncome' default='OTHER BANKING INCOME' /></ColumnDesc></RowStart>
              {fundsMgmtIncomeEnabled && <RowStart height={rowHeight}><ColumnDesc><TranslatedText size='s' value='ourFinancials.divisionalProfitLoss.fundsIncome' default='Funds Management Income' /></ColumnDesc></RowStart>}
            </TableSection>
            <TableSection>
              <RowStart height={rowHeight}><ColumnDesc><TranslatedText size='s' bold uppercase value='ourFinancials.divisionalProfitLoss.totalIncome' default='TOTAL INCOME' /></ColumnDesc></RowStart>
              <RowStart height={rowHeight}><ColumnDesc><TranslatedText size='s' value='ourFinancials.divisionalProfitLoss.operatingExpenses' default='Operational Expenses' /></ColumnDesc></RowStart>
            </TableSection>
            <TableSection>
              <RowStart height={rowHeight}><ColumnDesc><TranslatedText size='s' medium colour={theme.colours.blue} value='ourFinancials.divisionalProfitLoss.costToIncomeRatio' default='Cost to Income Ratio' /></ColumnDesc></RowStart>
              <RowStart height={rowHeight}><ColumnDesc><TranslatedText size='s' value='ourFinancials.divisionalProfitLoss.loanImpairmentExpense' default='Loan Impairment Expense' /></ColumnDesc></RowStart>
              <RowStart height={rowHeight}><ColumnDesc><TranslatedText size='s' medium colour={theme.colours.blue} value='ourFinancials.divisionalProfitLoss.loanImpairmentRatio' default='Loan Impairment Expense %' /></ColumnDesc></RowStart>
            </TableSection>
            <TableSection>
              <RowStart height={rowHeight}><ColumnDesc><TranslatedText size='s' value='ourFinancials.divisionalProfitLoss.netProfitBeforeTax' default='Net Profit Before Tax' /></ColumnDesc></RowStart>
              <RowStart height={rowHeight}><ColumnDesc><TranslatedText size='s' value='ourFinancials.divisionalProfitLoss.taxExpense' default='Tax Expense' /></ColumnDesc></RowStart>
            </TableSection>
            <TableSection>
              <RowStart height={rowHeight} style={{ ...borderHack, backgroundColor: '#eeeeee' }}><ColumnDesc><TranslatedText size='s' bold uppercase value='ourFinancials.divisionalProfitLoss.netProfitAfterTax' default='NET PROFIT AFTER TAX' /></ColumnDesc></RowStart>
            </TableSection>
          </Column1>
          {this.renderForBusinesses(({ b, colour }) => {
            return (
              <Column2 key={`${b.businessId}`}>
                <TableSection style={{ backgroundColor: theme.colours.darkBlue }}>
                  <Row height={rowHeight}><Text size='s' bold white>{mapNames(b.businessName).toUpperCase()}</Text></Row>
                  <Row height={rowHeight}>
                    <ColumnChange colour='transparent'><Text size='s' medium white uppercase>{`${translate('general.year', 'YEAR')} ${round - 1}`}</Text></ColumnChange>
                    <ColumnChange><TranslatedText size='s' medium white uppercase value='general.change' default='CHANGE' /></ColumnChange>
                  </Row>
                </TableSection>
                {loaded ? (
                  <>
                    <TableSection>
                      <Row height={rowHeight}>
                        <ColumnValue colour={colour}><Text size='s'>{formatValue(b.interestIncome)}</Text></ColumnValue>
                        <ColumnChange><ValueChangeText size='s' removePlusSign value={b.interestIncomeChange} dp={1} isCost={false} changeUnit='%' dashIfZero /></ColumnChange>
                      </Row>
                      <Row height={rowHeight}>
                        <ColumnValue style={borderHack} colour={colour}><Text size='s'>{formatValue(b.interestExpense)}</Text></ColumnValue>
                        <ColumnChange><ValueChangeText size='s' removePlusSign value={b.interestExpenseChange} dp={1} isCost changeUnit='%' dashIfZero /></ColumnChange>
                      </Row>
                    </TableSection>
                    <TableSection>
                      <Row height={rowHeight}>
                        <ColumnValue colour={colour}><Text bold size='s'>{formatValue(b.netInterestIncome)}</Text></ColumnValue>
                        <ColumnChange><ValueChangeText size='s' removePlusSign bold value={b.netInterestIncomeChange} dp={1} isCost={false} changeUnit='%' dashIfZero /></ColumnChange>
                      </Row>
                      <Row height={rowHeight}>
                        <ColumnValue colour={colour}><Text medium colour={theme.colours.blue} size='s'>{formatPercentage(b.nim)}</Text></ColumnValue>
                        <ColumnChange><ValueChangeText largeThreshold={9999} size='s' removePlusSign value={b.nimChange} dp={1} isCost={false} changeUnit='bps' dashIfZero /></ColumnChange>
                      </Row>
                      <Row height={rowHeight}>
                        <ColumnValue colour={colour}><Text size='s'>{formatValue(b.brokerCommissions)}</Text></ColumnValue>
                        <ColumnChange><ValueChangeText size='s' removePlusSign value={b.brokerCommissionsChange} dp={1} isCost changeUnit='%' dashIfZero /></ColumnChange>
                      </Row>
                      <Row height={rowHeight}>
                        <ColumnValue colour={colour}><Text size='s'>{formatValue(b.cardIncome)}</Text></ColumnValue>
                        <ColumnChange><ValueChangeText size='s' removePlusSign value={b.cardIncomeChange} dp={1} isCost={false} changeUnit='%' dashIfZero /></ColumnChange>
                      </Row>
                      {creditCardsEnabled && (
                        <Row height={rowHeight}>
                          <ColumnValue colour={colour}><Text size='s'>{formatValue(b.cardFees)}</Text></ColumnValue>
                          <ColumnChange><ValueChangeText size='s' removePlusSign value={b.cardFeesChange} dp={1} isCost={false} changeUnit='%' dashIfZero /></ColumnChange>
                        </Row>
                      )}
                      {creditCardsEnabled && (
                        <Row height={rowHeight}>
                          <ColumnValue colour={colour}><Text size='s'>{formatValue(b.rewardCosts)}</Text></ColumnValue>
                          <ColumnChange><ValueChangeText size='s' removePlusSign value={b.rewardCostsChange} dp={1} isCost changeUnit='%' dashIfZero /></ColumnChange>
                        </Row>
                      )}
                      {institutionalBankingEnabled && (
                        <Row height={rowHeight}>
                          <ColumnValue colour={colour}><Text size='s'>{formatValue(b.institutionalFees)}</Text></ColumnValue>
                          <ColumnChange><ValueChangeText size='s' removePlusSign value={b.institutionalFeesChange} dp={1} isCost={false} changeUnit='%' dashIfZero /></ColumnChange>
                        </Row>
                      )}
                    </TableSection>
                    <TableSection>
                      <Row height={rowHeight}>
                        <ColumnValue style={fundsMgmtIncomeEnabled ? {} : borderHack} colour={colour}><Text bold size='s'>{formatValue(b.totalOtherBankingIncome)}</Text></ColumnValue>
                        <ColumnChange><ValueChangeText size='s' removePlusSign bold value={b.totalOtherBankingIncomeChange} dp={1} isCost={false} changeUnit='%' dashIfZero /></ColumnChange>
                      </Row>
                      {fundsMgmtIncomeEnabled && (
                        <Row height={rowHeight}>
                          <ColumnValue style={borderHack} colour={colour}><Text size='s'>{formatValue(b.fundsMgmtIncome)}</Text></ColumnValue>
                          <ColumnChange><ValueChangeText size='s' removePlusSign value={b.fundsMgmtIncomeChange} dp={1} isCost={false} changeUnit='%' dashIfZero /></ColumnChange>
                        </Row>
                      )}
                    </TableSection>
                    <TableSection>
                      <Row height={rowHeight}>
                        <ColumnValue colour={colour}><Text bold size='s'>{formatValue(b.totalIncome)}</Text></ColumnValue>
                        <ColumnChange><ValueChangeText size='s' removePlusSign bold value={b.totalIncomeChange} dp={1} isCost={false} changeUnit='%' dashIfZero /></ColumnChange>
                      </Row>
                      <Row height={rowHeight}>
                        <ColumnValue colour={colour}><Text size='s'>{formatValue(b.opex)}</Text></ColumnValue>
                        <ColumnChange><ValueChangeText size='s' removePlusSign value={b.opexChange} dp={1} isCost changeUnit='%' dashIfZero /></ColumnChange>
                      </Row>
                    </TableSection>
                    <TableSection>
                      <Row height={rowHeight}>
                        <ColumnValue colour={colour}><Text medium colour={theme.colours.blue} size='s'>{formatPercentage(b.ctir)}</Text></ColumnValue>
                        <ColumnChange><ValueChangeText largeThreshold={9999} size='s' removePlusSign value={b.ctirChange} isCost changeUnit='bps' dashIfZero /></ColumnChange>
                      </Row>
                      <Row height={rowHeight}>
                        <ColumnValue colour={colour}><Text size='s'>{formatValue(b.lie)}</Text></ColumnValue>
                        <ColumnChange><ValueChangeText size='s' removePlusSign value={b.lieChange} dp={1} isCost changeUnit='%' dashIfZero /></ColumnChange>
                      </Row>
                      <Row height={rowHeight}>
                        <ColumnValue style={borderHack} colour={colour}><Text size='s' medium colour={theme.colours.blue}>{formatPercentage(b.lieRate)}</Text></ColumnValue>
                        <ColumnChange><ValueChangeText largeThreshold={9999} size='s' removePlusSign value={b.lieRateChange} isCost changeUnit='bps' dashIfZero /></ColumnChange>
                      </Row>
                    </TableSection>
                    <TableSection>
                      <Row height={rowHeight}>
                        <ColumnValue colour={colour}><Text size='s'>{formatValue(b.netProfitBeforeTax)}</Text></ColumnValue>
                        <ColumnChange><ValueChangeText size='s' removePlusSign value={b.netProfitBeforeTaxChange} dp={1} isCost={false} changeUnit='%' dashIfZero /></ColumnChange>
                      </Row>
                      <Row height={rowHeight}>
                        <ColumnValue colour={colour}><Text size='s'>{formatValue(b.tax)}</Text></ColumnValue>
                        <ColumnChange><ValueChangeText size='s' removePlusSign value={b.taxChange} dp={1} isCost changeUnit='%' dashIfZero /></ColumnChange>
                      </Row>
                    </TableSection>
                    <TableSection>
                      <Row height={rowHeight} style={{ ...borderHack, backgroundColor: '#eeeeee' }}>
                        <ColumnValue colour='#eeeeee'><Text bold size='s'>{formatValue(b.netProfitAfterTax)}</Text></ColumnValue>
                        <ColumnChange><ValueChangeText size='s' removePlusSign bold value={b.netProfitAfterTaxChange} dp={1} isCost={false} changeUnit='%' dashIfZero /></ColumnChange>
                      </Row>
                    </TableSection>
                  </>) : <CenteredSpinner />}
              </Column2>
            )
          })}
        </Table>
      </Container>
    )
  }
}

export default LoadAfterDelay(FinancialDivisionProfitAndLoss, { delay: 100 })
